<template>
  <div>
    <div class="free-dashboard-container">
      <div class="popup-dashboard-content">
        <div class="popup-dashboard-content-tabs">
          <div class="popup-dashboard-content-tab" :class="{active: tab === 'kids'}" @click="setParentModeActiveTab('kids')">
            {{$lang.messages.free_dashboard.tabs.my_kids}}
          </div>
          <div class="popup-dashboard-content-tab" :class="{active: tab === 'guest'}" @click="setParentModeActiveTab('guest')">
            {{$lang.messages.free_dashboard.tabs.one_time_session}}
          </div>
        </div>
        <div class="popup-dashboard-content-block" v-if="tab === 'kids'" >
          <div class="flex mb-1 popup-dashboard-content-tab-header">
            <div class="popup-manage-kid-image">
              <img src="../assets/img/popup-manage-kid.svg" alt="manage kids">
            </div>
            <p class="popup-manage-kid-text text-white">
              {{$lang.messages.free_dashboard.tabs.kids_description}}
            </p>
          </div>
          <div class="dashboard-content" v-if="profiles">
            <div v-if="isPremium" class="dashboard-profile-list">
              <div class="dashboard-profile"
                   :key="name"
                   v-for="(profile, name) in profiles">
                <a href="#" class="profile-edit-btn" @click.prevent="openProfile(name, activeProfiles.includes(name))">
                  <svg class="settings-icon"><use xlink:href="#icon-settings"></use></svg>
                </a>
                <div class="locked-profile-image" @click="openProfile(name, activeProfiles.includes(name))">
                  <img :src="profile.avatar || $avatars[profile.defaultAvatarId ? profile.defaultAvatarId : 13]" alt="avatar">
                </div>
                <div class="locked-profile-name">
                  {{ profile.kidName || 'Kid' }} <br>
                </div>
                <button class="btn btn-main -shadow" :disabled="activeProfiles.includes(name)" @click.stop="lockDeviceWithProfile(name)" >
                  <small v-if="activeProfiles.includes(name)">{{$lang.messages.free_dashboard.kids.profile_is_active}}</small>
                  <span v-else>{{$lang.messages.start}} <span class="nowrap">{{$lang.messages.kids_mode}}</span></span>
                </button>
              </div>
              <div class="dashboard-profile add-profile pointer" @click="goToAddChild">
                <div>
                  <div class="add-profile-plus">+</div>
                  <div class="add-profile-label">{{$lang.messages.free_dashboard.kids.add_kid}}</div>
                </div>
              </div>
            </div>
            <div v-else class="dashboard-profile-list">
              <div class="dashboard-profile">
                <a href="#" class="profile-edit-btn" @click.prevent="openProfile('defaultProfileSettings')">
                  <svg class="settings-icon"><use xlink:href="#icon-settings"></use></svg>
                </a>
                <div class="locked-profile-image" @click="openProfile('defaultProfileSettings')">
                  <img
                      :src="profiles['defaultProfileSettings'].avatar || $avatars[profiles['defaultProfileSettings'].defaultAvatarId ? profiles['defaultProfileSettings'].defaultAvatarId : 13]"
                      alt="avatar">
                </div>
                <div class="locked-profile-name">
                  {{ profiles['defaultProfileSettings'].kidName || 'Kid ' }} <br>
                </div>
                <button class="btn btn-main -shadow"
                        :disabled="activeProfiles.includes('defaultProfileSettings')"
                        @click.stop="lockDeviceWithProfile('defaultProfileSettings')">
                  <small v-if="activeProfiles.includes('defaultProfileSettings')">{{$lang.messages.free_dashboard.kids.profile_is_active}}</small>
                  <span v-else>{{$lang.messages.start}} <span class="nowrap">{{$lang.messages.kids_mode}}</span></span>
                </button>
              </div>
              <div class="dashboard-profile add-profile pointer" @click="goToPremiumDashboard">
                <div>
                  <div class="add-profile-plus">+</div>
                  <div class="add-profile-label">{{$lang.messages.free_dashboard.kids.add_kid}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center mt-1">
            <a href="#" class="hiw-button" @click.prevent="HIWContent = 'kids'; showHIW = true;">{{$lang.messages.free_dashboard.how_it_works.title}}</a>
          </div>
        </div>
        <div class="popup-dashboard-content-block" v-if="tab === 'guest'" >
          <div class="flex mb-1 popup-dashboard-content-tab-header">
            <div class="popup-manage-kid-image">
              <img src="../assets/img/popup-one-time-gear.svg" alt="manage kids" />
            </div>
            <p class="popup-manage-kid-text text-white">
              {{$lang.messages.free_dashboard.tabs.one_time_session_description}}
            </p>
          </div>
          <div class="form-group">
            <label class="form-label">{{$lang.messages.free_dashboard.one_time_session.time_limit}}</label>
            <div class="form-control-icon">
              <i class="icon-in-input icon-timer"></i>
              <v-select
                  :placeholder="'Please choose session time'"
                  :label="sessionLimitOptions.label"
                  :value="sessionLimitOptions.find(item => item.value === guestProfileAtCurrentDevice.todayDailyLimit)"
                  :clearable="false"
                  :searchable="false"
                  @input="changeSessionTimeLimit"
                  :options="sessionLimitOptions">
                <template slot="open-indicator">
                  <svg class="vs__open-indicator" width="20" height="10" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 0.5L5.5 5L10 0.5" stroke="#7D6AED" stroke-width="2"/>
                  </svg>
                </template>
              </v-select>
            </div>
            <div class="form-error" v-if="timeLimitError">
              {{$lang.messages.add_profile.choose_time}}
            </div>
          </div>
          <div class="form-group">
            <div class="form-label">{{$lang.messages.free_dashboard.one_time_session.allowed_sites}}</div>
            <div class="popup-locked-help" :class="{active: guestProfileAtCurrentDevice.links}" @click.prevent="openLinks">
              <div class="popup-locked-help-title">
                    <span v-if="guestProfileAtCurrentDevice.links || guestProfileAtCurrentDevice.allowAllLinks">
                      <span v-if="guestProfileAtCurrentDevice.allowAllLinks">{{$lang.messages.free_dashboard.one_time_session.allowed_all_links}}</span>
                      <span v-else>{{$lang.messages.free_dashboard.one_time_session.added}} {{guestProfileAtCurrentDevice.links.length}} {{$lang.messages.free_dashboard.one_time_session.sites}}</span>
                    </span>
                <span v-else>{{$lang.messages.free_dashboard.one_time_session.choose_sites}}</span>
              </div>
              <div class="popup-locked-help-text" v-if="guestProfileAtCurrentDevice.links && !guestProfileAtCurrentDevice.allowAllLinks">
                    <span v-for="(link, index) in guestProfileAtCurrentDevice.links" :key="index">
                      {{link.title}}
                      <span v-if="index < guestProfileAtCurrentDevice.links.length - 1">, </span>
                    </span>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="form-label">{{$lang.messages.exit_passcode}}</div>
            <div class="form-control-icon">
              <InputPassword
                  passwordVisible="true"
                  maxLength="4"
                  customplaceholder="Enter your passcode"
                  v-on:changepassword=changePassCode
                  :value="oneTimePassword"/>
              <i class="icon-in-input icon-locked"></i>
            </div>
            <div class="form-error" v-if="passCodeError">
              {{$lang.messages.passcode_error}}
            </div>
          </div>
          <div class="text-center">
            <button class="btn btn-main -shadow" @click="startSession">{{$lang.messages.free_dashboard.one_time_session.start_session}}</button>
          </div>
          <div class="text-center mt-1">
            <a href="#" class="hiw-button" @click.prevent="HIWContent = 'guest';showHIW = true;">{{$lang.messages.free_dashboard.how_it_works.title}}</a>
          </div>
        </div>
        <div class="popup-dashboard-footer mt-2" v-if="isPremium" @click="$router.push('/dashboard')">
          <div class="popup-dashboard-footer-large">{{$lang.messages.free_dashboard.footer.parent}}</div> {{$lang.messages.free_dashboard.footer.dashboard}}
          <img src="../assets/img/popup-dashboard.svg" alt="parent dashboard">
        </div>
        <div class="pm-dashboard-footer mt-1" v-else>
          <div>
            <div class="pm-dashboard-title">
              {{$lang.messages.free_dashboard.footer.features}}
            </div>
            <div class="features-labels-list">
              <div class="feature-label">
                <i class="icon-star active"></i>
                {{$lang.messages.free_dashboard.footer.feature_1}}
              </div>
              <div class="feature-label">
                <i class="icon-star active"></i>
                {{$lang.messages.free_dashboard.footer.feature_2}}
              </div>
              <div class="feature-label">
                <i class="icon-star active"></i>
                {{$lang.messages.free_dashboard.footer.feature_3}}
              </div>
            </div>
          </div>
          <div class="labeled-button-wrap">
            <div class="btn-label">{{$lang.messages.parent_dashboard}}</div>
            <button class="btn btn-main -shadow text-heavy" @click="goToPremiumDashboard">
              {{$lang.messages.get_premium}}
            </button>
          </div>
        </div>
      </div>
    </div>
    <Modal v-if="screen === 'addchild'" @hidemodal="screen = ''" lowheader="true">
      <AddChildPopup
          slot="content"
          v-on:showaddlinkmodal="showAddLinkModal = true"
          v-on:adddeviceshow="addDeviceShow = true"
          v-on:closeaddchild="screen = ''"/>
    </Modal>
    <Modal v-if="showGuestLinksModal" size="lg" @hidemodal="showGuestLinksModal = false" classNames="modal-sites" lowheader="true">
      <Sites slot="content" :profile="guestProfileAtCurrentDevice" profileId="guestProfileAtCurrentDevice" />
    </Modal>
    <Modal v-if="showHIW" size="sm" @hidemodal="showHIW = false">
      <div slot="header">{{$lang.messages.free_dashboard.how_it_works.title}}</div>
      <div slot="content" v-if="HIWContent === 'kids'">
        <p>{{$lang.messages.free_dashboard.how_it_works.kids.part_1}} <i class="icon-settings-bold color-main"></i> {{$lang.messages.free_dashboard.how_it_works.kids.part_2}}</p>
        <p>{{$lang.messages.free_dashboard.how_it_works.kids.part_3}} <span class="btn btn-main -shadow btn-sm">{{$lang.messages.start_kids_mode}}</span> {{$lang.messages.free_dashboard.how_it_works.kids.part_4}}</p>
        <div class="text-center">
          <button class="btn btn-main -shadow -min-width" @click="showHIW = false">{{$lang.messages.got_it}}</button>
        </div>
      </div>
      <div slot="content" v-if="HIWContent === 'guest'">
        <p class="mb-2">{{$lang.messages.free_dashboard.how_it_works.guest.part_1}}<br>
          {{$lang.messages.free_dashboard.how_it_works.guest.part_2}}<br>
          {{$lang.messages.free_dashboard.how_it_works.guest.part_3}}</p>
        <div class="text-center">
          <button class="btn btn-main -shadow -min-width" @click="showHIW = false">{{$lang.messages.got_it}}</button>
        </div>
      </div>
    </Modal>
    <AddDevice v-if="addDeviceShow"
               v-on:closepopup="addDeviceShow = false"
               defaultOpenScreen="mobile"/>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import InputPassword from "@/components/InputPassword";
import AddChildPopup from "@/components/AddChildPopup";
import Modal from "@/components/common/Modal";
import {isFourDigit} from "@/helpers/utils";
import saveSetting from "./mixins/saveSetting";
import Sites from "@/components/Sites";
import AddDevice from "@/components/AddDevice";
import {sessionLimitOptions} from "@/helpers/configs";
import {reportEvent} from "@/helpers/utils";

export default {
  name: "FreeDashboardContent",
  components: {InputPassword, AddChildPopup, Modal, Sites, AddDevice},
  mixins: [saveSetting],
  data: function () {
    return {
      locked: false,
      tab: sessionStorage.getItem('parentModeActiveTab') || 'kids',
      screen: '',
      showKidProfile: false,
      showPaymentModal: false,
      showGuestLinksModal: false,
      editedProfileId: 'defaultProfileSettings',
      passCodeError: false,
      timeLimitError: false,
      oneTimePassword: this.$store.state.accountData.password,
      showHIW: false,
      HIWContent: null,
      addDeviceShow: false,
      isAndroid: window.Android,
      sessionLimitOptions
    }
  },
  mounted() {
    if (this.guestProfileAtCurrentDevice.created) {
      this.saveGuestProfile({
        ...this.guestProfileAtCurrentDevice,
        ...{
          created: false,
        }
      })
    }
  },
  computed: {
    ...mapGetters({
      profileAtCurrentDevice: 'profileAtCurrentDevice',
      guestProfileAtCurrentDevice: 'guestProfileAtCurrentDevice',
      currentDevice: 'currentDevice'
    }),
    ...mapState({
      isPremium: state => state.accountData.isPremium,
      devices: state => state.accountData.devices,
      profiles: state => state.accountData.profiles,
      user: state => state.user,
      currentDeviceID: state => state.currentDeviceID,
      accountPassword: state => state.accountData.password,
    }),
    activeList() {
      return this.recommendedLinksPopup.filter(link => link.category === this.activeTab && (link.age === this.kidAge || link.age === 'all'));
    },
    activeProfiles() {
      const activeProfilesArray = [];
      Object.keys(this.devices).forEach(key => {
        const profileIdAtDevice = this.devices[key].currentProfileID;
        if (profileIdAtDevice) {
          activeProfilesArray.push(profileIdAtDevice);
        }
      })
      return activeProfilesArray;
    }
  },
  methods: {
    setParentModeActiveTab(tabId) {
      sessionStorage.setItem('parentModeActiveTab', tabId);
      this.tab = tabId;
    },
    goToAddChild(){
      this.screen = 'addchild';
    },
    changeSessionTimeLimit(option){
      this.saveGuestProfile({todayDailyLimit: option.value});
    },
    changePassCode(event){
      this.oneTimePassword = event;
    },
    startSession() {
      if (!isFourDigit(this.oneTimePassword)) {
        this.passCodeError = true;
      } else if (!this.guestProfileAtCurrentDevice.todayDailyLimit) {
        this.timeLimitError = true;
      } else {
        this.passCodeError = false;
        this.timeLimitError = false;

        this.saveGuestProfile({
          dailyLimitUsed: 0,
          passCode: this.oneTimePassword,
        }).then(()=> {
          reportEvent('startKidsMode', {
            isRemote: false,
          });
          this.saveDeviceSettings(this.currentDeviceID,
              {
                locked: true,
                currentProfileID: 'guestProfileAtCurrentDevice',
              });
        })
      }
    },
    goToPremiumDashboard(){
      const route = this.$router.resolve({path: '/dashboard'});
      window.open(route.href, '_blank');
      /*if(this.isPremium){
        this.$router.push('/dashboard')
      } else {
        this.premiumFeatures = true
      }*/
    },
    openProfile(profileId, profileActive) {
      if(!profileActive){
        this.$router.push(`profile/${profileId}`)
      } else {
        this.$dtoast.pop({
          preset: "error",
          heading: "You can't edit already active profile",
        })
      }
    },
    openLinks() {
      this.showGuestLinksModal = true;
    },
    lockDeviceWithProfile(profileId) {
      reportEvent('startKidsMode', {
        isRemote: false,
      });
      this.saveDeviceSettings(this.currentDeviceID,
          {
            locked: true,
            currentProfileID: profileId,
          });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/styles/helpers";
.free-dashboard-container {
  max-width: 724px;
  margin: 50px auto;
  position: relative;
  z-index: 1;

  @include responsive-below($sm){
    margin: 32px auto;
  }
}

.popup-dashboard-content {
  padding: 0;
  position: relative;
  z-index: 1;
}

.popup-dashboard-content-tabs {
  padding: 0 70px;

  @include responsive-below($xs){
    padding: 0 30px;
  }
}
.popup-dashboard-footer {
  margin: 15px 0;
}

.popup-dashboard-content {
  .dashboard-profile-list {
    justify-content: center;
    overflow: auto;
    gap: 8px;
  }

  .dashboard-profile {
    max-width: 197px;
    min-height: 216px;
    border-radius: 8px;
  }

  .add-profile-plus {
    width: 75px;
    height: 75px;
    line-height: 60px;
    margin-bottom: 29px;
  }

  .locked-profile-image {
    padding: 5px;
    width: 89px;
    height: 89px;
  }

  .locked-profile-name {
    margin-bottom: 20px;
  }
}

.popup-dashboard-content-block {
  padding: 48px;

  @include responsive-below($xs){
    padding: 20px;
  }
}

.popup-dashboard-content-tab-header {
  @include responsive-below($xs){
    flex-wrap: wrap;
  }

  .btn {
    align-self: center;
    margin-left: 24px;
  }
}

.popup-dashboard-content-tab-header-image {
  width: 72px;
  height: 72px;
  background: linear-gradient(86.48deg, rgba(239, 241, 255, 0.3) 12.26%, rgba(239, 241, 255, 0.1) 80.57%);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
}

.popup-dashboard-content-tab-header-text {
  background: linear-gradient(89.14deg, rgba(239, 241, 255, 0.1) 0%, rgba(239, 241, 255, 0) 100%);
  border-radius: 8px;
  color: #fff;
  padding: 10px 24px;
  display: flex;
  font-size: 18px;
  line-height: 24px;
  align-items: center;

  @include responsive-below($xs){
    width: calc(100% - 100px)
  }
}

.hiw-button {
  align-self: center;
  color: #fff;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  margin-left: auto;
  white-space: nowrap;

  @include responsive-below($xs){
    width: 100%;
    text-align: center;
    margin-top: 16px;
  }
}
</style>